'use strict';

var config = {
  // GraphQL connection settings
  server: calcGqlUrl(process.env.REACT_APP_ENV || process.env.VITE_ENV),
  secret:
    process && process.env && process.env.GQL_SEC
      ? process.env.GQL_SEC
      : process.env.GRAPHQL_SECRET
      ? process.env.GRAPHQL_SECRET
      : null,

  // User-specific client
  apollo_client: null,

  // DMS plugin credentials for CDK
  cdk_user: process && process.env && process.env.CDK_USER ? process.env.CDK_USER : null,
  cdk_password: process && process.env && process.env.CDK_PASSWORD ? process.env.CDK_PASSWORD : null,

  // API key for making calls to Google services
  google_places_key:
    process && process.env && process.env.REACT_APP_GPLCS
      ? process.env.REACT_APP_GPLCS
      : process.env.VITE_GPLCS
      ? process.env.VITE_GPLCS
      : process.env.REACT_APP_GOOGLE_PLACES_API_KEY
      ? process.env.REACT_APP_GOOGLE_PLACES_API_KEY
      : process.env.VITE_GOOGLE_PLACES_API_KEY
      ? process.env.VITE_GOOGLE_PLACES_API_KEY
      : null,
  google_timezone_key: process && process.env && process.env.GT_KEY ? process.env.GT_KEY : null,
  google_distance_key: process && process.env && process.env.GDM_KEY ? process.env.GDM_KEY : null,

  // Stripe credentials
  stripe_key: process && process.env && process.env.STRIPE_SK ? process.env.STRIPE_SK : null,
  stripe_webhook_secret: process && process.env && process.env.STRIPE_WS ? process.env.STRIPE_WS : null,

  // Dwolla credentials
  dwolla_env: 
    process && process.env && 
    (process.env.REACT_APP_ENV === 'production' || process.env.VITE_ENV === 'production') 
      ? 'production' 
      : 'sandbox',
  dwolla_key: process && process.env && process.env.DWLA_KEY ? process.env.DWLA_KEY : null,
  dwolla_secret: process && process.env && process.env.DWLA_SEC ? process.env.DWLA_SEC : null,

  calcGqlUrl,
  setServerFromEnv: env => {
    config.server = calcGqlUrl(env);
  },
};

function calcGqlUrl(env) {
  let gqlUrl;
  let env_lower = env || 'test'; // if nothing comes in assume test env
  env_lower = env_lower.toLowerCase(); // make sure case doesnt mess us up
  switch (env_lower) {
    case 'production':
    case 'prod':
      gqlUrl = 'https://gql.hopdrive.io/v1/graphql';
      break;
    case 'test':
    case 'development':
    case 'dev':
      gqlUrl = 'https://gql-test.hopdrive.io/v1/graphql';
      break;
    default:
      gqlUrl = 'https://gql-test.hopdrive.io/v1/graphql';
      break;
  }
  return gqlUrl;
}

module.exports = config;
